import { useMemo, useState } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { AppMessageFriendsRequests } from '../AppMessageFriendsRequests';
import { AppMessagePlayerCard, getBottomState } from '../AppMessagePlayerCard';
import { TextLabel } from '../TextLabel';
import {
	StyledContainer,
	StyledFriendsByStatusContainer,
	StyledFriendsContainer,
	StyledFriendsList,
	StyledHeadContainer,
	StyledOfflineStatusContainer,
	StyledOnlineStatusContainer,
	StyledSearchInput,
} from './AppMessageFriendsTab.styled';

const AppMessageFriendsTab = () => {
	const [searchInputValue, setSearchInputValue] = useState('');

	const onlineFriends = useMemo(() => new Array(10).fill(0), []);
	const offlineFriends = useMemo(() => new Array(10).fill(0), []);

	const totalRows = useMemo(
		() => Math.ceil((onlineFriends.length + offlineFriends.length) / 3),
		[onlineFriends, offlineFriends],
	);

	return (
		<StyledContainer>
			<StyledHeadContainer>
				<TextLabel style={{ fontSize: 18, fontWeight: 500, color: '#ffffff' }}>
					Мои друзья
				</TextLabel>
				<StyledSearchInput
					placeholder={'Введите имя игрока для поиска'}
					value={searchInputValue}
					onChange={(e) => setSearchInputValue(e.target.value)}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				/>
				<AppMessageFriendsRequests />
			</StyledHeadContainer>
			<StyledFriendsContainer>
				{/* <StyledNotFoundContainer> */}
				{/* 	<TextLabel> */}
				{/* 		К сожалению, но игрока с ником “{searchInputValue}”<br /> */}
				{/* 		не удалось найти */}
				{/* 	</TextLabel> */}
				{/* </StyledNotFoundContainer> */}
				<StyledFriendsByStatusContainer>
					<StyledOnlineStatusContainer>
						<div className={'dot'} />
						<TextLabel>В сети</TextLabel>
					</StyledOnlineStatusContainer>
					<StyledFriendsList>
						{onlineFriends.map((_, i) => (
							<AppMessagePlayerCard
								nickname={'stdian'}
								online
								key={i}
								index={i}
								bottom={getBottomState(Math.ceil((i + 1) / 3), totalRows)}
							/>
						))}
					</StyledFriendsList>
				</StyledFriendsByStatusContainer>
				<StyledFriendsByStatusContainer>
					<StyledOfflineStatusContainer>
						<div className={'dot'} />
						<TextLabel>Не в сети</TextLabel>
					</StyledOfflineStatusContainer>
					<StyledFriendsList>
						{offlineFriends.map((_, i) => (
							<AppMessagePlayerCard
								nickname={'stdian'}
								key={i}
								index={i}
								bottom={getBottomState(
									Math.ceil((onlineFriends.length + i + 1) / 3),
									totalRows,
								)}
							/>
						))}
					</StyledFriendsList>
				</StyledFriendsByStatusContainer>
			</StyledFriendsContainer>
		</StyledContainer>
	);
};

export { AppMessageFriendsTab };
